// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIDel } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('../../constants/actionTypes');

// @actions
const signaturePatternActions = require('actions/signaturePattern');

const removeTppKeyInProgress = () => ({
    type: actionTypes.TPP_KEYS_REMOVE_TPP_KEY_IN_PROGRESS
});

const retryRemoveConsentTpp = () => ({
    type: actionTypes.TPP_KEYS_CONSENT_RETRY_REMOVE
});

const removeConsentTppSuccess = () => ({
    type: actionTypes.TPP_KEYS_CONSENT_TPP_SUCCESS
});

const removeConsentTppFailure = (error) => ({
    type:  actionTypes.TPP_KEYS_CONSENT_TPP_FAILURE,
    payload: error
});

const removeConsent = (consentId, dataToken) => dispatch => {
    const query = {
        dataToken,
        id: consentId
    };
    const params = {
        consentId: consentId
    };

    const request = {
        query,
    };
    dispatch(removeTppKeyInProgress());

    return APIDel(dispatch, apiURLBuilder.getURL('tppRemoveConsent', params), request)
        .then(() => dispatch(removeConsentTppSuccess()))
        .catch(error => {
            if (error) {
                dispatch(removeConsentTppFailure(error.error.description))
            } else {
                throw error;
            }
        })
}

const validateRemoveConsent = (consentId) => (dispatch, getState) => {
    const removeCallback = (dispatch, _, dataToken) => {
        dispatch(removeConsent(consentId, dataToken));
    };
    dispatch(signaturePatternActions.validateAndExecute(dispatch, getState, removeCallback));
}

module.exports = {
    validateRemoveConsent,
    retryRemoveConsentTpp
}